import {
  useIssueMicrosoftOAuthUrlMutation,
  useStoreMicrosoftOAuthCredentialForPlannerAccountMutation,
  useRevokeMicrosoftOAuthTokenForPlannerAccountMutation,
} from './useMicrosoftAuthorization.generated'
import { OAuthProvider } from '@/types/schema.generated'
import { toValue } from 'vue'
import type { MaybeRefOrGetter } from 'vue'

export const ENTRANCE_GUID_STORAGE_KEY = 'ms_oauth_entranceGUID'

export const useMicrosoftAuthorizationForPlannerAccount = (
  entranceGUID: MaybeRefOrGetter<string>
) => {
  const { location } = document
  // 社内セキュリティで設定しているエンプラ企業もあるので、redirectUriは原則変更禁止
  // Azure AD のアプリに登録した redirect URI と厳密に一致している必要があるため、
  // 動的なパラメータは query params ではなく sessionStorage に保存・復元する
  const redirectUri = `${location.protocol}//${location.host}/settings/calendar-auth/callback`

  const issueOAuthUrlMutation = useIssueMicrosoftOAuthUrlMutation()
  const issueOAuthUrl = async () => {
    // Save entranceGUID to sessionStorage before redirect
    sessionStorage.setItem(ENTRANCE_GUID_STORAGE_KEY, toValue(entranceGUID))

    const res = await issueOAuthUrlMutation.mutate({
      redirectUri: redirectUri,
    })
    if (res?.data) {
      return res.data.issueMicrosoftOAuthURL.url
    }
    throw new Error(`error issueOAuthUrl: ${res}`)
  }

  const storeOAuthCredentialMutation =
    useStoreMicrosoftOAuthCredentialForPlannerAccountMutation()
  const storeOAuthCredential = (code: string) => {
    return storeOAuthCredentialMutation.mutate({
      code,
      redirectUri,
    })
  }

  const revokeOAuthTokenMutation =
    useRevokeMicrosoftOAuthTokenForPlannerAccountMutation()

  const revoke = async () =>
    await revokeOAuthTokenMutation.mutate({
      input: {
        provider: OAuthProvider.Microsoft,
      },
    })

  return {
    // TODO
    issueOAuthUrl,
    storeOAuthCredential,
    revoke,
  }
}
